export const DRAG_TYPES = {
	MODULE: 'module',
	SUBMODULE: 'submodule',
	SUBSUBMODULE: 'subsubmodule',
	SUBMODULE_CONTENT: 'submodule-content',
	FORM_FIELD: 'form-field',
	FORM_FIELD_OPTION: 'form-field-option',
	FORM_SECTION: 'form-section',
};
